import React from 'react';
import { Icons } from '@hyperping/design';
import GlowingDots from './GlowingDots';

const ProblemSolutionBlock = ({
  title,
  points,
  solution,
}) => {
  return (
    <div className="features-monitoring flex flex-direction-column width-100 gap-2em" style={{maxWidth: '890px', margin: '0 auto'}}>
      <h1 className="font-weight-600" style={{ color: 'white', fontSize: '2.5em', marginBottom: '0' }}>{title}</h1>
      {points && 
        <>
          <div className="flex flex-direction-column gap-1em">
            {points.map((point, i) => (
              <div key={'point-' + i} className="flex align-items-center gap-1em">
                <Icons name="close" size="small" style={{ color: '#ef4444', minWidth: '20px', minHeight: '20px' }} />
                <span className="font-weight-normal" style={{ color: 'white', fontSize: '1em' }}>{point}</span>
              </div>
            ))}
          </div>

          <div style={{borderTop: '1px solid #1F2937', width: '60%', marginLeft: 'auto', marginRight: 'auto'}} />
        </>
      }

      {solution && <div style={{
        position: 'relative',
        overflow: 'hidden',
        backgroundColor: 'rgba(6, 78, 59, 0.3)',
        borderRadius: '8px',
        border: '1px solid rgba(5, 150, 105, 0.5)',
        padding: '1em 1.5em',
      }}>
        <div style={{
          position: 'absolute',
          right: 0,
          top: -15,
          opacity: 0.8,
          maskImage: 'linear-gradient(to left, black, transparent)',
          WebkitMaskImage: 'linear-gradient(to left, black, transparent)',
        }}>
          <GlowingDots lines={4} brightProbability={0.07} />
        </div>
        <div className="flex align-items-center gap-1em" style={{position: 'relative', zIndex: 1}}>
          <Icons name="check" size="small" style={{color: '#10b981', minWidth: '20px', minHeight: '20px'}} />
          <span className="font-weight-500" style={{color: 'white', fontSize: '1em'}}>{solution}</span>
        </div>
      </div>}
    </div>
  );
};

export default ProblemSolutionBlock;
